import React, { useEffect } from "react";
import { Api, createConfigFromApi } from "@lib/utils";
import { useSocket, useApp } from "@lib/providers";
import { ChannelHeader } from "./ChannelHeader";
import { ChannelContainer, ChannelsWrap, AppContainer } from "./styles";
import { CommsCenterHeader } from "./CommsCenterHeader";
import { Transcription } from "./Transcription";
import * as T from "@types";

export type AppProps = {
  onReady?: (transcript: T.AppConfig) => void;
};

export const App: React.FC<AppProps> = ({ onReady }: AppProps) => {
  const { accessToken, darkMode, setConfig } = useApp();

  const { messageHistory, sendMessage } = useSocket();

  const listenChannel = ({ organizationId, channel }: { organizationId: string; channel: T.ChannelApiResponse }) => {
    sendMessage(
      JSON.stringify({
        messageType: "REGISTER_CHANNEL",
        organizationId: organizationId,
        itemId: channel.id,
        contentType: "RADIO"
      })
    );
  };

  const fetchOrganizations = async () => {
    const response: T.RadioStartupApiResponse = await Api.getRadioStartup();
    if (response) {
      const appConfig = createConfigFromApi(response);
      setConfig(appConfig);
      if (typeof onReady === "function") {
        onReady(appConfig);
      }

      response.channels.map((channel) => {
        listenChannel({ organizationId: response.organizationId, channel });
      });
    }
  };

  useEffect(() => {
    Api.init({ accessToken });
    fetchOrganizations();
  }, []);

  return (
    <AppContainer darkMode={darkMode}>
      <CommsCenterHeader />
      <ChannelHeader />
      <ChannelsWrap>
        <ChannelContainer>
          {messageHistory.map((transcription: T.TranscriptionWSResponse) => {
            return transcription.message.messageType === "AWARE" ? (
              <Transcription transcription={transcription} key={transcription.syncId} />
            ) : null;
          })}
        </ChannelContainer>
      </ChannelsWrap>
      {/* <KeywordAlert /> */}
    </AppContainer>
  );
};
